import React from 'react';
import LearningTab from './LearningTab';
import { Box, Button, Text } from '@chakra-ui/react';
import TabTemplate from '../../common/TabTemplate/TabTemplate';

const LearningPotential = ({ tabsData }: any) => {
	const tabs = tabsData?.data || [
		{ text: 'Unlock a World of Knowledge', data: 'Content of Tab 1' },
		{ text: 'Highlights1', data: 'Content of Tab 2' },
	];

	return (
		<Box>
			<Text p={4} as="h2" textStyle="h2" style={{ textAlign: 'center' }} display={{ base: 'none', md: 'block' }}>
				{tabsData?.heading}
			</Text>
			<Text p={4} as="h3" textStyle="h3" display={{ md: 'none' }} style={{ textAlign: 'center' }}>
				{tabsData?.heading}
			</Text>

			<Box mt="24px" maxW="1054px" mx="auto" isolation='isolate'>
				<TabTemplate
					tabs={tabs}
					tabBoxProps={{
						top: '0',
						px: '16px',
						overflowX: 'auto',
						overflowY: 'hidden',
						position: 'relative',
					}}
					tabPanelProps={{ px: { base: '16px' } }}
					tabListProps={{
						display: 'flex',
						width: '100%',
						minW: 'fit-content',
						justifyContent: 'center',
						gap: { base: '0px', md: '24px' },
					}}
					tabProps={{
						width: { base: '100%', md: 'auto' },
						flex: { base: '1 1 0%', md: '0' },
						whiteSpace: 'pre !important',
					}}
					customTabPanel={(data: any) => {
						return <LearningTab {...data?.data} />;
					}}
				/>
			</Box>
		</Box>
	);
};

export default LearningPotential;
